import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

const { flexCenter } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  border-radius: ${theme.borderRadius.circle};
  background-color: ${theme.colors.n500};
  width: 20px;
  height: 20px;
  ${flexCenter()}
`;

const activeStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    background-color: ${theme.colors.red};
  `;

const largeStyles = ({ isLarge }) =>
  isLarge &&
  css`
    width: 28px;
    height: 28px;
  `;

const darkStyles = ({ theme, isDark }) =>
  isDark &&
  css`
    background-color: ${theme.colors.n900};
    color: ${theme.colors.white};
  `;

const Dot = styled('div')(baseStyles, activeStyles, largeStyles, darkStyles);

Dot.propTypes = {
  isActive: PropTypes.bool,
  isLarge: PropTypes.bool,
  isDark: PropTypes.bool,
};

export default Dot;
